import { Component, Vue } from 'vue-property-decorator';

/**
 * N-291 (T5b, «8A»): cerrar una ficha con cambios sin guardar pregunta antes (`AvisoSinGuardar`). Lo mismo que hizo
 * T3 en la ficha del presupuesto, para los formularios del catálogo.
 *
 * Se compara «lo que GUARDAR mandaría» (`loQueSeGuardaria`, que da cada ficha) con la foto de cuando se abrió
 * (`fotoSinCambios`, en el `$nextTick` tras pintarse: con las piezas ya montadas). No el modelo a secas: hay fichas que
 * trabajan sobre su copia en pestañas o tablas (Paquete, la tabla de precios de un servicio extra nuevo).
 */
@Component
export default class AvisoAlCerrar extends Vue {
	alCargar: string | null = null;
	avisoCerrar = false;

	/** Lo que GUARDAR mandaría ahora, en texto. Cada ficha da el suyo. */
	loQueSeGuardaria(): string {
		return '';
	}

	fotoSinCambios() {
		this.$nextTick(() => {
			this.alCargar = this.loQueSeGuardaria();
		});
	}

	/** Método y no `get`: hay fichas que leen sus pestañas por `$refs`, que no avisa. */
	hayCambios(): boolean {
		return this.alCargar !== null && this.loQueSeGuardaria() !== this.alCargar;
	}

	alCerrar() {
		if (this.hayCambios()) {
			this.avisoCerrar = true;
			return;
		}
		this.$emit('close');
	}

	cerrarSinGuardar() {
		this.avisoCerrar = false;
		this.$emit('close');
	}
}
